exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".actions-button[data-v-5c5d4be9] {\n  min-height: 22px !important;\n  padding: 0;\n}", ""]);

// exports
